export default __webpack_public_path__ + "static/media/app.548910ba.png";